import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "address-select-text"
}

import { ref, watch, nextTick } from 'vue';
import type { CascaderProps, ElCascader } from 'element-plus';
// @ts-ignore
import { getQueryProv, getQueryCity, getQueryCoun } from '@/apis/modules/logistics';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {},
    width: { default: '100%' },
    mode: { default: 'select' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const apiMap = { 0: getQueryProv, 1: getQueryCity, 2: getQueryCoun };
const nameMap = { 0: { name: 'nameProv', code: 'codeProv' }, 1: { name: 'nameCity', code: 'codeCity' }, 2: { name: 'nameCoun', code: 'codeCoun' } };

const props = __props;
const cascaderValue = ref<string[] | string>([]);
const isSelect = ref<boolean>(true);
const cascaderRef = ref<InstanceType<typeof ElCascader> | null>(null);
const cascaderProps: CascaderProps = {
  lazy: true,
  async lazyLoad(node, resolve) {
    const { level, value } = node;
    const nodeLevel = level as 0 | 1 | 2;
    if (level === 3) {
      return resolve([]);
    }
    try {
      const res = await apiMap[nodeLevel]({ code: value });
      if (res.statusCode === 20000) {
        resolve(res.data.map((item: any) => ({ label: item[nameMap[nodeLevel].name], value: item[nameMap[nodeLevel].code], leaf: level === 2 })));
      }
    } catch (error) {
      console.error('Error loading data:', error);
    }
  },
};

const getLabels = (separator: string = '') => {
  if (!cascaderRef.value) {
    return '';
  }

  const str = cascaderRef.value!.presentText;
  return str && str.length
    ? str
      .split('/')
      .map(item => item.trim())
      .join(separator)
    : str;
};

const emits = __emit;

watch(
  () => props.modelValue,
  (newValue: string[] | string) => {
    cascaderValue.value = newValue;
  },
);
watch(() => props.mode, (newValue) => {
  isSelect.value = newValue === 'select';
},
  { immediate: true })

watch(cascaderValue, (newValue: string[] | string) => {
  emits('update:modelValue', newValue);
});

__expose({ getLabels });

return (_ctx: any,_cache: any) => {
  const _component_el_cascader = _resolveComponent("el-cascader")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ width: _ctx.width })
  }, [
    (isSelect.value)
      ? (_openBlock(), _createBlock(_component_el_cascader, _mergeProps({
          key: 0,
          class: "address-select",
          style: {"width":"100%"}
        }, _ctx.$attrs, {
          ref_key: "cascaderRef",
          ref: cascaderRef,
          modelValue: cascaderValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((cascaderValue).value = $event)),
          props: cascaderProps
        }), null, 16, ["modelValue"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.modelValue) + " ", 1),
          _createElementVNode("button", {
            class: "btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (isSelect.value = true))
          }, "修改")
        ]))
  ], 4))
}
}

})